import { Dialog } from 'vant'
import { getToken } from '@/utils/storage'
let loginPromptPromise = null
export const isLoggedIn = () => {
  return !!getToken()
}
/**
 * 未登录时：只弹一次“去登录”提示，并跳转到登录页（带 redirect）
 * 说明：这里不 import router，避免与 request/router 的循环依赖
 */
export const promptLoginOnce = (redirectPath = '') => {
  if (loginPromptPromise) return loginPromptPromise
  loginPromptPromise = Dialog.confirm({
    title: 'Notice',
    message: 'You need to log in to continue. Go to login now?',
    confirmButtonText: 'Go to Login',
    cancelButtonText: 'Cancel',
    closeOnClickOverlay: false
  })
    .then(() => {
      const redirect = redirectPath || (window.location.hash ? window.location.hash.replace(/^#/, '') : '/')
      const target = `/login?redirect=${encodeURIComponent(redirect)}`
      // hash 模式下直接改 hash，确保一定能跳转
      window.location.hash = `#${target}`
    })
    .catch(() => {
      // 用户取消
    })
    .finally(() => {
      loginPromptPromise = null
    })
  return loginPromptPromise
}
/**
 * 确保已登录：未登录则弹窗提示并返回 false
 */
export const ensureLoggedInOrPrompt = async (redirectPath = '') => {
  if (isLoggedIn()) return true
  promptLoginOnce(redirectPath)
  return false
}
